// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isSenderVerificationSendingDomainsPostResult = objectOf({
  domain: string,
  ip_pool_id: string,
  dns_records: arrayOf(
    objectOf({
      type: string,
      hostname: string,
      value: string,
    })
  ),
});
